/** Toolbar SVG icons (aligned with wankhede-360 DualCameraPreview). */

const iconProps = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export function PatrolIcon360() {
  return (
    <svg {...iconProps}>
      <ellipse cx="12" cy="12" rx="10" ry="5" />
      <path d="M2 12c0-2.8 4.5-5 10-5" />
    </svg>
  );
}

export function PatrolIconFlat() {
  return (
    <svg {...iconProps}>
      <rect x="3" y="6" width="18" height="12" rx="1.5" />
      <path d="M3 12h18" />
    </svg>
  );
}

export function PatrolIconSwitchCamera() {
  return (
    <svg {...iconProps}>
      <path d="M4 7h13l-2-2" />
      <path d="M20 17H7l2 2" />
    </svg>
  );
}

export function PatrolIconFullscreen() {
  return (
    <svg {...iconProps}>
      <path d="M4 9V4h5" />
      <path d="M20 9V4h-5" />
      <path d="M4 15v5h5" />
      <path d="M20 15v5h-5" />
    </svg>
  );
}

export function PatrolIconExitFullscreen() {
  return (
    <svg {...iconProps}>
      <path d="M9 4v5H4" />
      <path d="M15 4v5h5" />
      <path d="M9 20v-5H4" />
      <path d="M15 20v-5h5" />
    </svg>
  );
}

export function PatrolIconPipPopupVisible() {
  return (
    <svg {...iconProps}>
      <rect x="3" y="5" width="12" height="10" rx="1.5" />
      <rect x="14" y="9" width="7" height="6" rx="1" opacity={0.95} />
    </svg>
  );
}

export function PatrolIconPipPopupHidden() {
  return (
    <svg {...iconProps}>
      <rect x="3" y="5" width="12" height="10" rx="1.5" />
      <rect x="14" y="9" width="7" height="6" rx="1" opacity={0.45} />
      <path d="M4 20 20 4" strokeLinecap="round" />
    </svg>
  );
}
